import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  blockNumber: 0,
  eth: null,
  usdt: null,
  usd: null,
};

const contractBalanceSlice = createSlice({
  name: 'contractBalance',
  initialState,
  reducers: {
    contractBalanceUpdated(state, action) {
      const { payload } = action;
      if (!payload) return;

      // allow either shape:
      // 1) { blockNumber, eth, usdt, usd, updatedAt }
      // 2) { latestBlock, balances: { eth, usdt, ... }, updatedAt }
      const block =
        payload.blockNumber ?? payload.latestBlock ?? payload?.chain?.blockNumber ?? null;

      const balances = payload.balances ?? payload;

      if (block != null) state.blockNumber = Number(block) || state.blockNumber;
      if (payload.updatedAt) state.updatedAt = payload.updatedAt;

      state.eth = balances.eth ?? state.eth;
      state.usdt = balances.usdt ?? state.usdt;
      state.usd = balances.usd ?? state.usd;
    },
  },
});

export const { contractBalanceUpdated } = contractBalanceSlice.actions;
export default contractBalanceSlice.reducer;
